export default __webpack_public_path__ + "static/media/IMG_20210706_175824.53af0f33.jpg";